import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from '../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
//import HtlPeriods from "./HtlPeriods";
import HtlAgnOffExit from "./HtlAgnOffExit";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';




const GET_POST = gql`
query MyQuery(
    $rulPernId: Int
    $rulSubId: Int
    $rulPremId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    ) {
        tbl_rules_sub_premises(where: {
        r_prn_id_seq: {_eq: $rulPernId}
        r_sub_id_seq: {_eq: $rulSubId}
        id_seq: { _eq: $rulPremId }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
    }) {
    id_seq
    r_prn_id_seq
    r_sub_id_seq
    firm_main_code
    firm_sub_code
    start_date_v1
    end_date_v1
    start_date_v2
    end_date_v2
    pre_type
    opr_1
    int_var_1
    str_var_long_1
    
 
  }
  tbl_rules_act(where: {
    r_pre_id: {_eq: $rulPremId}}) {
    id_seq
    r_sub_id   
    r_prn_id 
    firm_main_code
    firm_sub_code
    act_class
    act_type
    date_1
    start_date
    end_date
    pre_type
    opr_2
    str_var_1
    int_var_1
    
  }
  
}
`;




const INSERT_SEA = gql`
  mutation InsertRules(
    $rulPernId: Int
    $rulSubId: Int
    $rulPremId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $startDate: date
    $endDate: date
    $startDate2: date
    $endDate2: date
    $premType: String
    $premOpr: String
    $premIntV1: Int
    $rSubType: String
    $premStrLongV1: String

   
    
  ) {
    insert_tbl_rules_sub_premises(
      objects: {
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        r_prn_id_seq: $rulPernId,
        r_sub_id_seq: $rulSubId,
        id_seq: $rulPremId,
        pre_type: $premType,
        start_date_v1: $startDate,
        end_date_v1: $endDate,
        start_date_v2: $startDate,
        end_date_v2: $endDate,
        opr_1: $premOpr,
        int_var_1: $premIntV1,
        r_sub_type: $rSubType,
        str_var_long_1: $premStrLongV1,
        
       

        
      }
    ) {
      affected_rows
    }
  }
`;


const GET_RULES_CLS = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass2: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
        opt_1: { _eq: $ruleClass2 },
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;

const GET_WEEKDAYS = gql`
  query MyQuery( $lang: String, $defType: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
       
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;



const UPDATE_RULES = gql`
mutation UpdateRules(
    $rulPernId: Int
    $rulSubId: Int
    $rulPremId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $startDate: date
    $endDate: date
    $startDate2: date
    $endDate2: date
    $premType: String
    $premOpr: String
    $premIntV1 : Int
    $premStrLongV1: String
    
    
  ) {
    update_tbl_rules_sub_premises(
      where: {
        r_prn_id_seq: {_eq: $rulPernId}
        r_sub_id_seq: {_eq: $rulSubId}
        id_seq: { _eq: $rulPremId }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      }
      _set: {
        
       
        start_date_v1: $startDate
        end_date_v1: $endDate
        start_date_v2: $startDate2
        end_date_v2: $endDate2
        pre_type: $premType
        opr_1: $premOpr
        int_var_1: $premIntV1
        str_var_long_1: $premStrLongV1
      }
    ) {
      affected_rows
    }
  }
`; 

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;






const HtlAgnOffPremises = () => {

   const {varCode, setVarCode} = useContext(ThemeContext);
   const {varCode2, setVarCode2} = useContext(ThemeContext);
   const {varCode8, setVarCode8} = useContext(ThemeContext);
   const {varCode9, setVarCode9} = useContext(ThemeContext);
   const {varCode10, setVarCode10} = useContext(ThemeContext);
   const {varCode11, setVarCode11} = useContext(ThemeContext); // EBO
   const {varCode13, setVarCode13} = useContext(ThemeContext); // EBO
  const {userName, setUserName} = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

  const lang = users.userLang;

 
  
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { rulPernId: varCode, 
        ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode,
         rulSubId: varCode8 ,rulPremId: varCode10 },
  });


  const firmData = data && data.tbl_rules_sub_premises ? data.tbl_rules_sub_premises[0] : null;
  const firmData2 = data && data.tbl_rules_sub_premises ? data.tbl_rules_sub_premises[0] : null;
 

  const [updateRulesSub] = useMutation(UPDATE_RULES);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertSeason] = useMutation(INSERT_SEA);

  const [displayBasic, setDisplayBasic] = useState(false);

  
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState(""); 
 const [rulSubId, setRulSubnId] = useState(firmData ? firmData.r_sub_id_seq : "");  
 const [rulPremId, setRulPremId] = useState(firmData ? firmData.id_seq : ""); 
 
  const [rulPernId, setRulPernId] = useState(firmData ? firmData.r_prn_id_seq : ""); 
  const [rulesName, setRulesName] = useState(firmData ? firmData.rules_sub_name : ""); 
  const [ruleType, setRulesType] = useState(firmData ? firmData.rules_sub_type : ""); 
  const [premType, setPremType] = useState(firmData ? firmData.pre_type : ""); 
  const [premOpr, setPremOpr] = useState(firmData ? firmData.opr_1 : ""); 
  const [premIntV1, setPremIntV1] = useState(firmData ? firmData.int_var_1 : null); 
  const [premStrLongV1, setPremStrLongV1] = useState(firmData ? firmData.str_var_long_1 : ""); 

  const [fmActive, setFmActive] = useState(firmData ? firmData.active : false);   
  const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date_v1): new Date());
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date_v1) : new Date());
  const [startDate2, setStartDate2] = useState(firmData ? new Date(firmData.start_date_v2): new Date());
  const [endDate2, setEndDate2] = useState(firmData ? new Date(firmData.end_date_v2) : new Date());

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);



  const [activeTab, setActiveTab] = useState(0);
  const [activeTabS, setActiveTabS] = useState(9);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleTabChangeS = (index) => {
    setActiveTabS(index);
  };



  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const res_start_date_title = messages[currentLocale].res_start_date_title;
  const res_end_date_title = messages[currentLocale].res_end_date_title;
  const stay_start_date_title = messages[currentLocale].stay_start_date_title;
  const stay_end_date_title = messages[currentLocale].stay_end_date_title;
  const rule_type_title = messages[currentLocale].rule_type_title;
  const new_result_btn = messages[currentLocale].new_result_btn;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const new_rule_btn = messages[currentLocale].new_rule_btn;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const update = messages[currentLocale].update;
  
  const years_old_title = messages[currentLocale].years_old_title;
  const rule_stay_day_title = messages[currentLocale].rule_stay_day_title;
  const result_management_title = messages[currentLocale].result_management_title;
  const rule_person_title = messages[currentLocale].rule_person_title;
  const rule_persent_title = messages[currentLocale].rule_persent_title;



  const messages4 = {
    EBO: messages[currentLocale].rule_ebo_title,
    SSO: messages[currentLocale].rule_sso_title,
    HMO: messages[currentLocale].rule_hmo_title,
    LSO: messages[currentLocale].rule_lso_title,
    GRPO: messages[currentLocale].rule_grp_title,
    default_message: 'Rules Management',
  };

  
  const close_form4 = messages4[varCode11] || messages4.default_message;

  const close_form = messages[currentLocale].close_form;
 
  const search_by_name = messages[currentLocale].search_by_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;
  const sea_new_btn = messages[currentLocale].sea_new_btn;
  const sea_Season_title = messages[currentLocale].sea_Season_title;
  
 
  const sea_management_title = messages[currentLocale].sea_management_title;
  const detail = messages[currentLocale].detail;
  
  const sea_id_title = messages[currentLocale].sea_id_title;
  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard;
  const sea_desc_title = messages[currentLocale].sea_desc_title;
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;
  const sea_new_per_btn = messages[currentLocale].sea_new_per_btn;


  const { loading: defLoading, error: defError, data: defData } = useQuery(GET_RULES_CLS, {
    variables: {lang: currentLocale, defType: "RLSG", ruleClass2: varCode9 },
  });

  const { loading: defLoading2, error: defError2, data: defData2 } = useQuery(GET_WEEKDAYS, {
    variables: {lang: currentLocale, defType: "WDAYS" },
  });




  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (rulPremId !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
    handleinser();  
    
    }
  }, [rulPremId, setRulPremId]);


  useEffect(() => {
    if (defData2 && defData2.tbl_gnl_def) {
      const rulesWeekDays = defData2.tbl_gnl_def.find(item => item.code === premType);
      if (rulesWeekDays) {
        setPremIntV1(rulesWeekDays.opt_1);
      }
    }
  }, [premType, setPremType, defData2]);

  

  useEffect(() => {
    if (firmData) {

        
        setRulPremId(firmData.id_seq);  
        setRulPernId(firmData.r_prn_id_seq);
        setRulSubnId(firmData.r_sub_id_seq);
        setRulesName(firmData.rules_sub_name);       
        setRulesType(firmData.rules_sub_type);
        setStartDate(new Date(firmData.start_date_v1));
        setEndDate(new Date(firmData.end_date_v1));
        setStartDate2(new Date(firmData.start_date_v2));
        setEndDate2(new Date(firmData.end_date_v2));        
        setPremType(firmData.pre_type);
        setPremOpr(firmData.opr_1);
        setPremIntV1(firmData.int_var_1);
        setPremStrLongV1(firmData.str_var_long_1);
     
          
    }
  }, [firmData]);

  useEffect(() => {
    switch (varCode11) {
      case "SSO":
        setPremType("AGE");
        break;
      case "LSO":
        setPremType("STY");
        break;
      case "GRPO":
        setPremType("PER");
        break;
        case "HMO":
          setPremType("STY");
          break;
          case "EBO":
            setPremType("STY");
            break;
      default:
        // Default case can be used to set a default value if necessary
        // setPremType("DEFAULT_VALUE");
        break;
    }
  }, [firmData, varCode11]);


  const handleUpdate = () => {
   
    
    updateRulesSub({
      variables: {
        rulPernId: varCode,
        rulSubId: varCode8,
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,  
        rulPremId: rulPremId,    
        premType: premType,  
        premOpr: premOpr,
        premIntV1: premIntV1,
        premStrLongV1: premStrLongV1,

        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        startDate2: new Date(startDate2).toLocaleDateString(),
        endDate2: new Date(endDate2).toLocaleDateString(),
        


       

        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    const requiredFields = ['premType' ]; // Required fiels
    const customFieldNames = {
      
    //  ruleClass: "Rules Class",
      premType: "Rules Type",

    

    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'MFIRM', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        setRulPremId(updatedIdSeq); 
     //   setIdSeqTrg(updatedIdSeq);
        
        console.log(rulPremId);
        // setVarCode(updatedIdSeq.toString());  
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      
      const emptyFieldsMessage = `Boş Alanları Doldurun: ${emptyFields.join(', ')}`;
     // console.log(emptyFieldsMessage);
      window.alert(emptyFieldsMessage);
    }
  };

  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
  
    // Boş olan alanları bul
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
  
    return emptyFields;
  };

  const handleinser = () => {
    InsertSeason({
      variables: {


        rulPernId: varCode,
        rulSubId: varCode8,
        rulPremId: rulPremId,  
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode, 
        rSubType: varCode11, 
          
        premType: premType, 
        premOpr: premOpr,
        premIntV1: premIntV1, 
        premStrLongV1: premStrLongV1,      
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        startDate2: new Date(startDate2).toLocaleDateString(),
        endDate2: new Date(endDate2).toLocaleDateString(),
   
           
      },
    })
      .then(() => {
        window.alert("Rules insert successfully!");
      })
      .catch((error) => {
        console.error("Error insert Rules:", error);
        console.error('Mutation error:', error);
        console.error('Extra error information:', error.graphQLErrors, error.networkError);
      });
  };


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

      
  const onClick = (rowData) => {
   // setVarCode13(0);
   
    setDisplayBasic(true);
    
  };

  const onClick2 = () => {
    setVarCode13(0);  
    setVarCode10(rulPremId);
    setDisplayBasic(true);
    
  };
  
  const onHide = () => {
    setDisplayBasic(false);
    refetch();
  };


  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-sm"
      : "text-gray-500 font-bold text-sm";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };


  const rulesClasstems = defData && defData.tbl_gnl_def
  ? defData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];


  const rulesWeekDays = defData2 && defData2.tbl_gnl_def
  ? defData2.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
      opt: item.opt_1,
    }))
  : [];






  return (

    <div className="container -mt-4 mx-auto sm:p-4 ">
      
  
   


         <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >

              
              
              {close_form4}
              
            </span>
          }
          className="ml-5 flex"
        >
      <div>

    
    <div className=" p-2 ">
        
         <div className="pt-1"> 
         {varCode11 === "EBO" && (
        
           <Fieldset>
             <p className="my-0  ">
      <div className="flex gap-4">
          <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Id"}</label>
    <InputText className="w-full text-base" 
    id="username" value={rulPremId}
    onChange={(e) => setRulPremId(e.target.value)}
    readOnly
    />
  </div> 


  
  <div className="w-2/4 h-10 gap-3">
        <label                
         htmlFor="firmname"> {res_start_date_title}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={startDate} dateFormat="dd/mm/yy"
        onChange={(e) => setStartDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>

      <div className="w-2/4 h-10 gap-3">
        <label                
         htmlFor="firmname"> {res_end_date_title}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={endDate} dateFormat="dd/mm/yy"
        onChange={(e) => setEndDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>  
  </div> 
 
  

  

  
  <div className="flex gap-3 my-5">

  <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{rule_type_title}</label>
    <InputText className="w-full text-base" 
    id="premtype" value={premType}
    onChange={(e) => setPremType(e.target.value)}
    
    />
  </div> 
  <div className="w-2/4 h-10 gap-3">
        <label                
         htmlFor="firmname"> {stay_start_date_title}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={startDate2} dateFormat="dd/mm/yy"
        onChange={(e) => setStartDate2(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>

      <div className="w-2/4 h-10 gap-3">
        <label                
         htmlFor="firmname"> {stay_end_date_title}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={endDate2} dateFormat="dd/mm/yy"
        onChange={(e) => setEndDate2(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>  
  </div> 

  
  
  
     
      
      <div className="flex  gap-4 ">
      <div className="w-2/4">
     
  </div>
  <div className="w-2/4">
    <Button
      label={new_result_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={onClick2}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={new_rule_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
    //  onClick={handleUpdateIdSeq}
    onClick={() => {               
      setPremIntV1(0);                         
      handleUpdateIdSeq();
    
      
    }}
    />
  </div>
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '45vw' }}header={result_management_title} onHide={onHide}>
  <p>
   <HtlAgnOffExit/>
  </p>
</Dialog>
</div>
</p>
   </Fieldset>

    )}   {/* EBO  */}

{varCode11 === "SSO" && (
        
        <Fieldset>
          <p className="my-0  ">
   <div className="flex gap-4">
       <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{"Id"}</label>
 <InputText className="w-full text-base" 
 id="username" value={rulPremId}
 onChange={(e) => setRulPremId(e.target.value)}
 readOnly
 />
</div> 
<div className="w-2/4 h-10 gap-3">
     <label                
      htmlFor="firmname"> {start_date_title}</label>
     <Calendar className="w-full h-11" 
     inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     style={{ width:"%80" }}    
     id="firmname" value={startDate} dateFormat="dd/mm/yy"
     onChange={(e) => setStartDate(e.target.value)} 
     showIcon
     locale="tr"/>
   </div>

   <div className="w-2/4 h-10 gap-3">
     <label                
      htmlFor="firmname"> {end_date_title}</label>
     <Calendar className="w-full h-11" 
     inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     style={{ width:"%80" }}    
     id="firmname" value={endDate} dateFormat="dd/mm/yy"
     onChange={(e) => setEndDate(e.target.value)} 
     showIcon
     locale="tr"/>
   </div>  
</div> 






<div className="flex gap-3 my-5">

<div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{rule_type_title}</label>
 <InputText className="w-full text-base" 
 id="premtype" value={premType}
 onChange={(e) => setPremType(e.target.value)}
 
 />
</div> 

<div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{years_old_title}</label>
 <InputText className="w-full text-base" 
 id="premtype" value={premIntV1}
 onChange={(e) => setPremIntV1(e.target.value)}
 
 />
</div> 



</div> 




  
   
   <div className="flex  gap-4 ">
   <div className="w-2/4">
  
</div>
<div className="w-2/4">
 <Button
   label={new_result_btn}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
   onClick={onClick2}
 />
</div>
<div className="w-2/4">
 <Button
   label={update}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
   onClick={handleUpdate}
 />
</div>
<div className="w-2/4">
 <Button
   label={new_rule_btn}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
   onClick={handleUpdateIdSeq}
 />
</div>
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '45vw' }}header={result_management_title} onHide={onHide}>
<p>
<HtlAgnOffExit/>
</p>
</Dialog>
</div>
</p>
</Fieldset>

 )}   {/* SSO  */}


{varCode11 === "LSO" && (
        
        <Fieldset>
          <p className="my-0  ">
   <div className="flex gap-4">
       <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{"Id"}</label>
 <InputText className="w-full text-base" 
 id="username" value={rulPremId}
 onChange={(e) => setRulPremId(e.target.value)}
 readOnly
 />
</div> 
<div className="w-2/4 h-10 gap-3">
     <label                
      htmlFor="firmname"> {start_date_title}</label>
     <Calendar className="w-full h-11" 
     inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     style={{ width:"%80" }}    
     id="firmname" value={startDate} dateFormat="dd/mm/yy"
     onChange={(e) => setStartDate(e.target.value)} 
     showIcon
     locale="tr"/>
   </div>

   <div className="w-2/4 h-10 gap-3">
     <label                
      htmlFor="firmname"> {end_date_title}</label>
     <Calendar className="w-full h-11" 
     inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     style={{ width:"%80" }}    
     id="firmname" value={endDate} dateFormat="dd/mm/yy"
     onChange={(e) => setEndDate(e.target.value)} 
     showIcon
     locale="tr"/>
   </div>  
</div> 






<div className="flex gap-3 my-5">

<div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{rule_type_title}</label>
 <InputText className="w-full text-base" 
 id="premtype" value={premType}
 onChange={(e) => setPremType(e.target.value)}
 
 />
</div> 

<div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{rule_stay_day_title}</label>
 <InputText className="w-full text-base" 
 id="premtype" value={premIntV1}
 onChange={(e) => setPremIntV1(e.target.value)}
 
 />
</div> 



</div> 




  
   
   <div className="flex  gap-4 ">
   <div className="w-2/4">
  
</div>
<div className="w-2/4">
 <Button
   label={new_result_btn}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
   onClick={onClick2}
 />
</div>
<div className="w-2/4">
 <Button
   label={update}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
   onClick={handleUpdate}
 />
</div>
<div className="w-2/4">
 <Button
   label={new_rule_btn}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
   onClick={handleUpdateIdSeq}
 />
</div>
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '45vw' }}header={result_management_title} onHide={onHide}>
<p>
<HtlAgnOffExit/>
</p>
</Dialog>
</div>
</p>
</Fieldset>

 )}   {/* LSO  */}

{varCode11 === "GRPO" && (
        
        <Fieldset>
          <p className="my-0  ">
   <div className="flex gap-4">
       <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{"Id"}</label>
 <InputText className="w-full text-base" 
 id="username" value={rulPremId}
 onChange={(e) => setRulPremId(e.target.value)}
 readOnly
 />
</div> 
<div className="w-2/4 h-10 gap-3">
     <label                
      htmlFor="firmname"> {start_date_title}</label>
     <Calendar className="w-full h-11" 
     inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     style={{ width:"%80" }}    
     id="firmname" value={startDate} dateFormat="dd/mm/yy"
     onChange={(e) => setStartDate(e.target.value)} 
     showIcon
     locale="tr"/>
   </div>

   <div className="w-2/4 h-10 gap-3">
     <label                
      htmlFor="firmname"> {end_date_title}</label>
     <Calendar className="w-full h-11" 
     inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     style={{ width:"%80" }}    
     id="firmname" value={endDate} dateFormat="dd/mm/yy"
     onChange={(e) => setEndDate(e.target.value)} 
     showIcon
     locale="tr"/>
   </div>  
</div> 






<div className="flex gap-3 my-5">

<div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{rule_type_title}</label>
 <InputText className="w-full text-base" 
 id="premtype" value={premType}
 onChange={(e) => setPremType(e.target.value)}
 
 />
</div> 

<div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{"Group Pax"}</label>
 <InputText className="w-full text-base" 
 id="premtype" value={premIntV1}
 onChange={(e) => setPremIntV1(e.target.value)}
 
 />
</div> 



</div> 




  
   
   <div className="flex  gap-4 ">
   <div className="w-2/4">
  
</div>
<div className="w-2/4">
 <Button
   label={new_result_btn}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
   onClick={onClick2}
 />
</div>
<div className="w-2/4">
 <Button
   label={update}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
   onClick={handleUpdate}
 />
</div>
<div className="w-2/4">
 <Button
   label={new_rule_btn}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
   onClick={handleUpdateIdSeq}
 />
</div>
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '45vw' }}header={result_management_title} onHide={onHide}>
<p>
<HtlAgnOffExit/>
</p>
</Dialog>
</div>
</p>
</Fieldset>

 )}   {/* GRP  */}

{varCode11 === "HMO" && (
        
        <Fieldset>
          <p className="my-0  ">
   <div className="flex gap-4">
       <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{"Id"}</label>
 <InputText className="w-full text-base" 
 id="username" value={rulPremId}
 onChange={(e) => setRulPremId(e.target.value)}
 readOnly
 />
</div> 
<div className="w-2/4 h-10 gap-3">
     <label                
      htmlFor="firmname"> {start_date_title}</label>
     <Calendar className="w-full h-11" 
     inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     style={{ width:"%80" }}    
     id="firmname" value={startDate} dateFormat="dd/mm/yy"
     onChange={(e) => setStartDate(e.target.value)} 
     showIcon
     locale="tr"/>
   </div>

   <div className="w-2/4 h-10 gap-3">
     <label                
      htmlFor="firmname"> {end_date_title}</label>
     <Calendar className="w-full h-11" 
     inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     style={{ width:"%80" }}    
     id="firmname" value={endDate} dateFormat="dd/mm/yy"
     onChange={(e) => setEndDate(e.target.value)} 
     showIcon
     locale="tr"/>
   </div>  
</div> 






<div className="flex gap-3 my-5">

<div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{rule_type_title}</label>
 <InputText className="w-full text-base" 
 id="premtype" value={premType}
 onChange={(e) => setPremType(e.target.value)}
 
 />
</div> 

<div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{rule_person_title}</label>
 <InputText className="w-full text-base" 
 id="premtype" value={premIntV1}
 onChange={(e) => setPremIntV1(e.target.value)}
 
 />
</div> 



</div> 




  
   
   <div className="flex  gap-4 ">
   <div className="w-2/4">
  
</div>
<div className="w-2/4">
 <Button
   label={new_result_btn}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
   onClick={onClick2}
 />
</div>
<div className="w-2/4">
 <Button
   label={update}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
   onClick={handleUpdate}
 />
</div>
<div className="w-2/4">
 <Button
   label={new_rule_btn}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
   onClick={handleUpdateIdSeq}
 />
</div>
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '45vw' }}header={result_management_title} onHide={onHide}>
<p>
<HtlAgnOffExit/>
</p>
</Dialog>
</div>
</p>
</Fieldset>

 )}   {/* HMO  */}

{varCode11 === "WDAY" && (
        
        <Fieldset>
          <p className="my-0  ">
   <div className="flex gap-4">
       <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{"Id"}</label>
 <InputText className="w-full text-base" 
 id="username" value={rulPremId}
 onChange={(e) => setRulPremId(e.target.value)}
 readOnly
 />
</div> 
<div className="w-2/4 h-10 gap-3">
     <label                
      htmlFor="firmname"> {start_date_title}</label>
     <Calendar className="w-full h-11" 
     inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     style={{ width:"%80" }}    
     id="firmname" value={startDate} dateFormat="dd/mm/yy"
     onChange={(e) => setStartDate(e.target.value)} 
     showIcon
     locale="tr"/>
   </div>

   <div className="w-2/4 h-10 gap-3">
     <label                
      htmlFor="firmname"> {end_date_title}</label>
     <Calendar className="w-full h-11" 
     inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     style={{ width:"%80" }}    
     id="firmname" value={endDate} dateFormat="dd/mm/yy"
     onChange={(e) => setEndDate(e.target.value)} 
     showIcon
     locale="tr"/>
   </div>  
</div> 








<div className="flex gap-3 my-5">

<div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{rule_type_title}</label>
 <InputText className="w-full text-base" 
 id="premtype" value={premType}
 onChange={(e) => setPremType(e.target.value)}
 
 />
</div> 

<div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{rule_person_title}</label>
 <InputText className="w-full text-base" 
 id="premtype" value={premIntV1}
 onChange={(e) => setPremIntV1(e.target.value)}
 
 />
</div> 

<div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"rule_class_name_title"}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" 
        style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={premType}
         options={rulesWeekDays}
         onChange={(e) => setPremType(e.value)}
         placeholder={"select_rule_class_hint"}
         />
       </div>



</div> 




  
   
   <div className="flex  gap-4 ">
   <div className="w-2/4">
  
</div>
<div className="w-2/4">
 <Button
   label={new_result_btn}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
   onClick={onClick2}
 />
</div>
<div className="w-2/4">
 <Button
   label={update}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
   onClick={handleUpdate}
 />
</div>
<div className="w-2/4">
 <Button
   label={new_rule_btn}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
   onClick={handleUpdateIdSeq}
 />
</div>
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '45vw' }}header={result_management_title} onHide={onHide}>
<p>
<HtlAgnOffExit/>
</p>
</Dialog>
</div>
</p>
</Fieldset>

 )}   {/* WDAY  */}


{varCode11 === "SDAY" && (
        
        <Fieldset>
          <p className="my-0  ">
   <div className="flex gap-4">
       <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{"Id"}</label>
 <InputText className="w-full text-base" 
 id="username" value={rulPremId}
 onChange={(e) => setRulPremId(e.target.value)}
 readOnly
 />
</div> 
<div className="w-2/4 h-10 gap-3">
     <label                
      htmlFor="firmname"> {start_date_title}</label>
     <Calendar className="w-full h-11" 
     inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     style={{ width:"%80" }}    
     id="firmname" value={startDate} dateFormat="dd/mm/yy"
     onChange={(e) => setStartDate(e.target.value)} 
     showIcon
     locale="tr"/>
   </div>

   <div className="w-2/4 h-10 gap-3">
     <label                
      htmlFor="firmname"> {end_date_title}</label>
     <Calendar className="w-full h-11" 
     inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
     style={{ width:"%80" }}    
     id="firmname" value={endDate} dateFormat="dd/mm/yy"
     onChange={(e) => setEndDate(e.target.value)} 
     showIcon
     locale="tr"/>
   </div>  
</div> 








<div className="flex gap-3 my-5">

<div className="w-1/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{rule_type_title}</label>
 <InputText className="w-full text-base" 
 id="premtype" value={premType}
 onChange={(e) => setPremType(e.target.value)}
 
 />
</div> 

<div className="w-4/5 p-inputtext-sm  flex-column gap-3">
 <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
  htmlFor="username">{'Description'}</label>
 <InputText className="w-full text-base" 
 id="premtype" value={premStrLongV1}
 onChange={(e) => setPremStrLongV1(e.target.value)}
 
 />
</div> 




</div> 




  
   
   <div className="flex  gap-4 ">
   <div className="w-2/4">
  
</div>
<div className="w-2/4">
 <Button
   label={new_result_btn}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
   onClick={onClick2}
 />
</div>
<div className="w-2/4">
 <Button
   label={update}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
   onClick={handleUpdate}
 />
</div>
<div className="w-2/4">
 <Button
   label={new_rule_btn}
   aria-label="Update"
   className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
   onClick={handleUpdateIdSeq}
 />
</div>
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '45vw' }}header={result_management_title} onHide={onHide}>
<p>
<HtlAgnOffExit/>
</p>
</Dialog>
</div>
</p>
</Fieldset>

 )}   {/* SDAY  */}
       </div>
 
       </div>          
  
  </div>


 <p> <DataTable
         value={data.tbl_rules_act }
         scrollable 
         scrollHeight="250px" loading={loading}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="id_seq"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Id"}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>
          <Column field="act_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{rule_type_title}</span>}
           style={{ textAlign: 'left', width: '8rem' }}
          >
          </Column>

          <Column field="int_var_1"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Value"}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>
          <Column field="str_var_1"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{rule_persent_title}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>

          <Column field="pre_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{rule_type_title}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>

          <Column
           field="date_1"
           header={<span className="font-bold text-sm text-gray-900">{"Date"}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.date_1;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
           

          return (
           <div className="text-sm">
           {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'left', width: '10rem' }}
           />

      
          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
                setVarCode13(rowData.id_seq);  
             //   setVarCode(rowData.sea_id_seq);                          
               onClick();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable></p>    

              </TabPanel>
              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Reduction & Supplement %"}
            </span>
          }
          className="ml-5 flex"
        >
    

              </TabPanel>
            
          </TabView>   
     
    </div>




    
    
    
 
 
);
};

export default HtlAgnOffPremises;
